import { useEffect, useState } from "react";
import { ServiceResponse } from "../../../app/services/shared/interfaces";
import { toast } from "react-toastify";
import { formatMoney } from "../../../utils/utils";
import useEventService from "../../../app/services/hooks/useEventService";


interface Props {
    travelEspensesFilter: any,
    setTravelEspensesFilter: (travelEspensesFilter: any) => void,
    setTravelExpensesDaysTotal: (total: number) => void,
    searchAction: boolean
}

const TravelExpensesContainer = ({ 
    travelEspensesFilter,
    setTravelEspensesFilter,
    setTravelExpensesDaysTotal,
    searchAction
}: Props) => {

    const { getTravelExpensesByEvents, fetchingGetTravelExpensesByEvents } = useEventService();


    const [eventDays, setEventDays] = useState<any[]>([]);
    const [travelExpensesTotal, setTravelExpensesTotal] = useState(0);
    const [travelExpenseShowData, setTravelExpenseShowData] = useState<boolean>(false);


    useEffect(()=>{

        if(travelEspensesFilter.worker_id){

            getTravelExpensesByEvents(travelEspensesFilter, {
                onSuccess: (response: ServiceResponse) => {
                    setTravelExpensesTotal(response.data.total_budget);
                    setEventDays(response.data.events_number);
                    setTravelExpensesDaysTotal(response.data.total_budget);
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            })
        }

    },[searchAction]);

    const showTravelExpensesData = () => {
        setTravelExpenseShowData(!travelExpenseShowData)
    };



    return (
        <>
            
                {/* CARD de viático calculados por días */}
                <div className="col-lg-3">
                    <div
                        className="mini-stats-wid card p-2 icon-pointer"
                        style={{
                            backgroundColor: '#BCCAB9',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        }}
                        onClick={showTravelExpensesData}
                    >
                        <div className="d-flex">
                            <div className="flex-grow-1">
                                <p className="fw-medium" style={{ userSelect: 'none' }}>Viáticos por días</p>
                                {fetchingGetTravelExpensesByEvents ? (
                                    <h5 className="mb-0">...</h5>
                                ) : (
                                    <h5 className="mb-0" style={{ userSelect: 'none' }}>{formatMoney(travelExpensesTotal)}</h5>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {travelExpenseShowData &&    
                    <div>            
                        <div className="row justify-content-start">
                            {eventDays ? eventDays.map((event, index) => {
                                return (
                                    <div className="col-lg-3 " key={index}>
                                        <div
                                            className="mini-stats-wid card p-2"
                                            style={{
                                                backgroundColor: '#BCCAB9',
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                            }}
                                        >
                                            <div className="d-flex">
                                                <div className="flex-grow-1">
                                                    <p className="fw-medium mb-0" style={{ userSelect: 'none' }}>
                                                        {event.days_number} {event.event_type}, 
                                                    </p>
                                                    <p className="font-size-10" style={{ userSelect: 'none' }}>
                                                        {formatMoney(event.travel_expense)} c/u
                                                    </p>
                                                    {!travelExpenseShowData ? (
                                                        <h5 className="mb-0">...</h5>
                                                    ) : (
                                                        <h5 className="mb-0" style={{ userSelect: 'none' }}>{formatMoney(event.total)}</h5>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }) 
                            : null
                            }
                        </div> 
                    </div>
                }

        </>
    )

}

export default TravelExpensesContainer;


